var accordionComponent = class extends HTMLElement {
    section = this.querySelectorAll(".accordion__section");
    title = this.querySelectorAll(".accordion__section-title");

    connectedCallback() {
        var that = this; // Store reference to "this" for later use in event listener
        this.title.forEach(function (title) {
            title.addEventListener("click", function (e) {
                that.toggleAccordion(e);
            });
        });
    }

    toggleAccordion(e) {
        let el = $(e.currentTarget);
        let content = el[0].nextElementSibling;
        let allParents = $(this).find(".accordion__section");
        let allContents = allParents.find(".accordion__section-content"); 

        if ($(el).parent().hasClass("open")) {
            el[0].parentElement.classList.toggle("open");
            content.classList.toggle("open");
            $(content).css("max-height", 0 + "px"); 

        } else { 
            allParents.removeClass("open");
            allContents.removeClass("open");
            $(allContents).css("max-height", 0 + "px");
            el[0].parentElement.classList.toggle("open");
            content.classList.toggle("open");
            $(content).css("max-height", content.scrollHeight + "px"); 

        }
    }
};

window.customElements.define("component-accordion", accordionComponent);
